import '@deere/ux.uxframe-core/dist/css/uxframe.min.css';
import App from './App';
import axiosInstance, {setupAxiosClient} from './axiosWrapper/axiosWrapper';
import axiosInstanceDD, {
  setupAxiosClientDD,
} from './axiosWrapper/axiosWrapperDD';
import axiosInstanceOcta, {
  setupAxiosClientOcta,
} from './axiosWrapper/axiosWrapperOkta';
import {appStore} from './redux/createStore';
import unleashConfig from './unleash-config';

import {FlagProvider} from '@unleash/proxy-client-react';
import log from 'loglevel';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';

log.setLevel('debug');

setupAxiosClient(appStore, axiosInstance);
setupAxiosClientOcta(appStore, axiosInstanceOcta);
setupAxiosClientDD(appStore, axiosInstanceDD);

const app = (
  <Provider store={appStore}>
    <FlagProvider config={unleashConfig}>
      <App />
    </FlagProvider>
  </Provider>
);
const root = createRoot(document.getElementById('root'));
root.render(app);
if ('serviceWorker' in navigator && process.env.PUBLIC_URL)
  window.addEventListener('load', () =>
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
      .then((registration) =>
        log.debug('Registration successful, scope is:', registration.scope)
      )
      .catch((err) =>
        log.error('Service worker registration failed, error:', err)
      )
  );
